import { Link } from "react-router-dom";
import type { Movie } from "@/types";

interface MovieCardProps {
  movie: Movie;
  className?: string;
}

function ratingTone(rating: number) {
  if (rating >= 8.5) return "bg-accent-500 text-foreground-950";
  if (rating >= 8) return "bg-secondary-500 text-background-50";
  return "bg-foreground-800/85 text-background-50";
}

export default function MovieCard({ movie, className = "" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className={`group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} - 555电影`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute right-2 top-2 rounded-md px-2 py-0.5 font-label text-xs font-bold ${ratingTone(
            movie.rating,
          )}`}
        >
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 md:text-base">
          {movie.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {movie.year} · {movie.region}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}